// Clean SVG moon-phase glyph. phase: 0 new .. 4 full .. 7 waning crescent.
// Renders a crisp lit limb + terminator instead of a flat two-tone split.
export default function MoonPhase({ phase = 0, size = 16, className = "" }) {
  const LIT = "#EFD89A", DARK = "#2f2a20", EDGE = "rgba(0,0,0,0.18)";
  const R = 49;
  const f = phase <= 4 ? phase / 4 : (8 - phase) / 4; // illuminated fraction 0..1
  const waxing = phase <= 4;
  const rx = Math.max(0.01, Math.abs(R * (2 * f - 1)));
  const sweep = (2 * f - 1) >= 0 ? 1 : 0;
  const litPath = `M50,1 A${R},${R} 0 1 1 50,99 A${rx},${R} 0 1 ${sweep} 50,1 Z`;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className}
      aria-label="moon phase" style={{ display: "inline-block", verticalAlign: "middle" }}>
      <circle cx="50" cy="50" r={R} fill={DARK} stroke={EDGE} strokeWidth="1.5" />
      {f > 0.01 && (
        <g transform={waxing ? undefined : "translate(100,0) scale(-1,1)"}>
          <path d={litPath} fill={LIT} />
        </g>
      )}
    </svg>
  );
}
